import React from 'react';

import { Button, ButtonProps } from '@mui/material';

import { bookingAnchor } from './BookingWidget';

// The booking widget lives on the Contact page; this button takes visitors to it.
export const bookingUrl = `/contact-us#${bookingAnchor}`;

function BookCallLink({ variant = 'outlined', sx }: Pick<ButtonProps, 'variant' | 'sx'>) {
  return (
    <Button
      href={bookingUrl}
      data-track='book_call'
      variant={variant}
      sx={sx}
    >
      Book a 20-minute call
    </Button>
  );
}

export default BookCallLink;
